import {useNavigate} from "react-router-dom";
import {IdleTimerProvider} from "react-idle-timer";
import {useAuth} from "base/auth";

const IdleLogoutTimer = ({children}) => {
    let navigate = useNavigate();
    const auth = useAuth();

    const onIdle = () => {
        navigate("/login", {state: {error: "IDLE_LOGOUT"}});
    };

    const onAction = event => {
        // Do something when a user triggers a watched event
    };

    return auth.user ? (
        <IdleTimerProvider
            timeout={1000 * parseInt(process.env.REACT_APP_IDLE_SECONDS_LOGOUT)}
            crossTab={true}
            name="idle-logout-timer"
            syncTimers={250}
            onIdle={onIdle}
            onAction={onAction}
        >
            {children}
        </IdleTimerProvider>
    ) : (
        children
    );
};

export default IdleLogoutTimer;
